import { Flex } from '@applyboard/crystal-ui';
import ThreeSixySolutionsHeading from '../../components/ThreeSixySolutionsHeading';
import VoucherDisplay from './VoucherDisplay';

function TestVouchersDashboard() {
  return (
    <Flex direction="column" gap={4}>
      <ThreeSixySolutionsHeading
        title="Voucher Management"
        description="Manage and assign test vouchers to students"
      />
      <VoucherDisplay />
    </Flex>
  );
}

export default TestVouchersDashboard;
